import { Article } from '../../../components';
import { withLayout } from '../../../Layout/Layout';
import { contentRedirect } from '../../../utils/contentRedirect';
import { httpGet } from '../../../utils/httpClient';

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking'
  };
};
export const getStaticProps = async ({ params }) => {
  const articleRes = await httpGet(
    `${process.env.javaApiUrl}/article/${params.id}`
  );
  const recommendationRes = await httpGet(
    `${process.env.javaApiUrl}/recommendation/airlines/articles/${params.id}`
  );

  const article = await articleRes.json();
  const redirectResult = contentRedirect(article, params.id, 'airlines', 'news');
  if (redirectResult) {
    return redirectResult;
  }

  if (articleRes.status >= 400) {
    return {
      notFound: true,
      revalidate: 60
    };
  }
  const recommendation = await recommendationRes.json();
  return {
    props: {
      article,
      recommendation
    },
    revalidate: 60
  };
};

function AirlineArticle({
                          article,
                          recommendation,
                          setLoginDialogState,
                          authCompleted
                        }) {
  return (
    <Article
      article={article}
      recommendation={recommendation}
      setLoginDialogState={setLoginDialogState}
      authCompleted={authCompleted}
    />
  );
}

export default withLayout(AirlineArticle, false);
